var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wait"},[_c('b-button',{staticClass:"btn-sm",attrs:{"variant":"bg"},on:{"click":_vm.onStart}},[_c('div',{staticClass:"button-text"},[_vm._t("buttonText",function(){return [_vm._v("Wait")]})],2),(_vm.buildState === 'IN_PROGRESS')?_c('Spinner',{attrs:{"size":20}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }